import React from "react";
import { connect } from "react-redux";
import axios from "axios";

import { Card } from "@mui/material";
import { withStyles } from "tss-react/mui";
import extendedFormsStyle from "../../assets/jss/material-dashboard-pro-react/views/extendedFormsStyle";
import CardBody from "../../components/Card/CardBody";
import SaveButton from "../../components/CustomInput/SaveButton";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";

import Table from "../../components/Table/Table.jsx";
import * as actions from "../../store/actions";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";
import { toast } from "react-toastify";
import { redirect } from "react-router";
import { Navigate, redirectDocument } from "react-router";

class Import extends React.Component {
  form = React.createRef();

  state = {
    saving: false,
    hasError: false,
    count: 1,
    items: [],
    hasFile: false,
  };

  handleFileUploadChange = () => {
    this.setState({
      hasFile: true,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({ saving: true });

    let data = new FormData(this.form.current);

    axios.post("core/preordering/import", data).then((response) => {
      this.setState({
        count: response.data.data.count,
        items: response.data.data.items,
        saving: false,
        hasError: false,
        errors: [],
      });
    });
  };

  renderRedirect = () => {
    toast.warn(
      <TranslationWrapper tDefault={"Selecteer eerst een vestiging"} tKey={"global.jamezzForm.error.selectVestiging"} />
    );

    return <Navigate to={"/manager/preordering"} />;
  };

  render() {
    let importedRows = this.state.items.map((item) => {
      return [item.status, item.datetime, item.name];
    });

    return (
      <Card>
        <CardBody>
          <GridContainer>
            <form onSubmit={this.handleSubmit} ref={this.form}>
              {this.props.vestiging_id == null || this.props.vestiging_id === "ALL" ? (
                this.renderRedirect()
              ) : (
                <input name={"vestiging_id"} type={"hidden"} value={this.props.vestiging_id} />
              )}
              <GridContainer>
                <GridItem md={6} xs={12}>
                  <input name={"bestand"} onChange={this.handleFileUploadChange} type={"file"} />
                </GridItem>
                <GridItem md={6} style={{ textAlign: "right" }} xs={12}>
                  <a href={"/xlsx/jamezz-preordering-voorbeeld.xlsx"}>
                    <TranslationWrapper
                      tDefault={"Download voorbeeld bestand"}
                      tKey={"preordering.import.button.text.downloadVoorbeeld"}
                    />
                  </a>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem md={12} xs={12}>
                  <SaveButton
                    buttonText={
                      <TranslationWrapper tDefault={"Importeren"} tKey={"preordering.import.button.text.importeren"} />
                    }
                    disabled={!this.state.hasFile}
                    hasError={this.state.hasError}
                    onChange={this.handleImageChange}
                    saving={this.state.saving}
                    type={"submit"}
                  />
                </GridItem>
              </GridContainer>
              {this.state.count > 0 ? (
                <GridContainer>
                  <GridItem xs={12}>
                    <h1>
                      <TranslationWrapper tDefault={"Geïmporteerde rijen"} tKey={"preordering.import.output.title"} />
                    </h1>
                    <Table
                      tableData={importedRows}
                      tableHead={[
                        <TranslationWrapper tDefault={"Status"} tKey={"preordering.import.output.table.status"} />,
                        <TranslationWrapper tDefault={"Datum"} tKey={"preordering.import.output.table.datum"} />,
                        <TranslationWrapper tDefault={"Naam"} tKey={"preordering.import.output.table.naam"} />,
                      ]}
                      tableHeaderColor={"primary"}
                    />
                  </GridItem>
                </GridContainer>
              ) : null}
            </form>
          </GridContainer>
        </CardBody>
      </Card>
    );
  }
}

//REDUX
const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Import, extendedFormsStyle));
